import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useLanguage } from '../i18n/LanguageContext'
import MetaTags from '../components/MetaTags'
import Lightbox from '../components/Lightbox'

export default function GalleryPage() {
  const { t, getPageUrl } = useLanguage()
  const [galleries, setGalleries] = useState([])
  const [activeSlug, setActiveSlug] = useState('alle')
  const [lightboxIndex, setLightboxIndex] = useState(0)
  const [isLightboxOpen, setIsLightboxOpen] = useState(false)
  const [lightboxImages, setLightboxImages] = useState([])

  const defaultGalleries = [
    {
      gallery_slug: 'generelt',
      images: [
        'https://assets.auxodev.dk/assets/ed865070-334e-4849-904d-48dc93d1adc7/734101346-1054615956904113-4096849147404615392-n.jpg',
        'https://assets.auxodev.dk/assets/ed865070-334e-4849-904d-48dc93d1adc7/476816859-656735350025511-354367063843939379-n.jpg',
        'https://assets.auxodev.dk/assets/ed865070-334e-4849-904d-48dc93d1adc7/476448836-655303320168714-1260139362731958487-n.jpg',
        'https://assets.auxodev.dk/assets/ed865070-334e-4849-904d-48dc93d1adc7/470160342-1004853748354071-1772744319645786737-n.jpg',
        'https://assets.auxodev.dk/assets/ed865070-334e-4849-904d-48dc93d1adc7/470094745-1004853755020737-7287025073737737011-n.jpg',
        'https://assets.auxodev.dk/assets/ed865070-334e-4849-904d-48dc93d1adc7/206196946-165242755648512-6798365573135249439-n.jpg',
        'https://assets.auxodev.dk/assets/ed865070-334e-4849-904d-48dc93d1adc7/470065228-1004853678354078-8640809208142626719-n.jpg',
        'https://assets.auxodev.dk/assets/ed865070-334e-4849-904d-48dc93d1adc7/470183366-1004865451686234-2145888141808669137-n.jpg'
      ]
    },
    {
      gallery_slug: 'specialtransport',
      images: [
        'https://assets.auxodev.dk/assets/ed865070-334e-4849-904d-48dc93d1adc7/470065228-1004853678354078-8640809208142626719-n.jpg',
        'https://assets.auxodev.dk/assets/ed865070-334e-4849-904d-48dc93d1adc7/734101346-1054615956904113-4096849147404615392-n.jpg'
      ]
    },
    {
      gallery_slug: 'containerkoersel',
      images: [
        'https://assets.auxodev.dk/assets/ed865070-334e-4849-904d-48dc93d1adc7/470065228-1004853678354078-8640809208142626719-n.jpg',
        'https://assets.auxodev.dk/assets/ed865070-334e-4849-904d-48dc93d1adc7/470094745-1004853755020737-7287025073737737011-n.jpg'
      ]
    },
    {
      gallery_slug: 'stykgods',
      images: [
        'https://assets.auxodev.dk/assets/ed865070-334e-4849-904d-48dc93d1adc7/476816859-656735350025511-354367063843939379-n.jpg',
        'https://assets.auxodev.dk/assets/ed865070-334e-4849-904d-48dc93d1adc7/206196946-165242755648512-6798365573135249439-n.jpg'
      ]
    },
    {
      gallery_slug: 'traepiller',
      images: [
        'https://assets.auxodev.dk/assets/ed865070-334e-4849-904d-48dc93d1adc7/470183366-1004865451686234-2145888141808669137-n.jpg',
        'https://assets.auxodev.dk/assets/ed865070-334e-4849-904d-48dc93d1adc7/476448836-655303320168714-1260139362731958487-n.jpg'
      ]
    }
  ]

  useEffect(() => {
    fetch('https://api.dev.auxo.dk/public/content/galleries')
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          setGalleries(data)
        } else {
          setGalleries(defaultGalleries)
        }
      })
      .catch(() => setGalleries(defaultGalleries))
  }, [])

  const currentList = galleries.length > 0 ? galleries : defaultGalleries

  // Filter images
  let displayedImages = []
  if (activeSlug === 'alle') {
    const allImgs = new Set()
    currentList.forEach((g) => {
      if (Array.isArray(g.images)) {
        g.images.forEach((img) => allImgs.add(img))
      }
    })
    displayedImages = Array.from(allImgs)
  } else {
    const selected = currentList.find((g) => g.gallery_slug === activeSlug || (activeSlug === 'stykgods' && g.gallery_slug === 'stoebegods') || (activeSlug === 'stoebegods' && g.gallery_slug === 'stykgods'))
    displayedImages = selected && Array.isArray(selected.images) ? selected.images : []
  }

  const openLightboxForIndex = (index) => {
    setLightboxImages(displayedImages)
    setLightboxIndex(index)
    setIsLightboxOpen(true)
  }

  const categoryTabs = [
    { slug: 'alle', label: t.gallery.tabAll },
    { slug: 'specialtransport', label: t.servicesList.specialtransport?.title || 'Specialtransport' },
    { slug: 'containerkoersel', label: t.servicesList.containerkoersel?.title || 'Containerkørsel' },
    { slug: 'stykgods', label: t.servicesList.stykgods?.title || 'Styk gods transport' },
    { slug: 'traepiller', label: t.servicesList.traepiller?.title || 'Træpille transport' },
  ]

  return (
    <div className="bg-slate-50 min-h-screen pb-20">
      <MetaTags
        title={t.gallery.metaTitle}
        description={t.gallery.metaDesc}
      />

      {/* Header Banner */}
      <section className="bg-gradient-to-br from-slate-100 via-sky-50/60 to-white text-slate-900 py-12 lg:py-16 border-b border-slate-200 relative overflow-hidden">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-2xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight mb-4 text-slate-900">
              {t.gallery.headerTitle}
            </h1>
            <p className="text-slate-600 text-base sm:text-lg leading-relaxed">
              {t.gallery.headerSubtitle}
            </p>
          </div>
        </div>
      </section>

      {/* Filter Tabs */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10">
        <div className="flex flex-wrap gap-2 pb-4 border-b border-slate-200">
          {categoryTabs.map((tab) => (
            <button
              key={tab.slug}
              onClick={() => setActiveSlug(tab.slug)}
              className={`px-4 py-2 text-xs font-bold uppercase tracking-wider transition-all duration-200 cursor-pointer ${
                activeSlug === tab.slug
                  ? 'bg-sky-500 text-white shadow-sm'
                  : 'bg-white text-slate-700 hover:bg-slate-100 border border-slate-200'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </section>

      {/* Gallery Image Grid */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="mb-4 text-xs font-semibold text-slate-500 uppercase tracking-wider">
          {t.gallery.showingImages} {displayedImages.length} {t.gallery.imagesCount}
        </div>

        {displayedImages.length === 0 ? (
          <div className="text-center py-20 bg-white border border-slate-200">
            <p className="text-slate-500">{t.gallery.tabAll}</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
            {displayedImages.map((img, idx) => (
              <button
                key={idx}
                onClick={() => openLightboxForIndex(idx)}
                className="group relative aspect-[4/3] bg-slate-100 overflow-hidden border border-slate-200 shadow-sm hover:shadow-md transition-all text-left focus:outline-none focus:ring-2 focus:ring-sky-500 cursor-pointer"
              >
                <img
                  src={`https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/${img.replace('https://assets.auxodev.dk/', '')}`}
                  alt={`${t.gallery.headerTitle} ${idx + 1}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                
                {/* Hover overlay with zoom icon */}
                <div className="absolute inset-0 bg-slate-900/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center pointer-events-none">
                  <div className="w-12 h-12 rounded-full bg-sky-500 text-white flex items-center justify-center text-xl shadow-lg ring-2 ring-white transform scale-75 group-hover:scale-100 transition-transform">
                    <i className="fa-solid fa-magnifying-glass-plus"></i>
                  </div>
                </div>
              </button>
            ))}
          </div>
        )}
      </section>

      {/* CTA Box */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10">
        <div className="bg-sky-500 text-white p-8 sm:p-10 rounded-none shadow-lg flex flex-col sm:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-xl sm:text-2xl font-bold mb-2">
              {t.gallery.ctaText}
            </h2>
            <p className="text-sky-100 text-sm">
              {t.home.heroSubtitle}
            </p>
          </div>
          <Link
            to={getPageUrl('contact')}
            className="bg-slate-900 hover:bg-slate-950 text-white font-bold py-3 px-6 rounded-none whitespace-nowrap shadow transition-colors text-sm"
          >
            {t.gallery.ctaBtn}
          </Link>
        </div>
      </section>

      {/* Lightbox Modal */}
      <Lightbox
        images={lightboxImages}
        currentIndex={lightboxIndex}
        isOpen={isLightboxOpen}
        onClose={() => setIsLightboxOpen(false)}
        onPrev={() => setLightboxIndex((prev) => (prev > 0 ? prev - 1 : lightboxImages.length - 1))}
        onNext={() => setLightboxIndex((prev) => (prev < lightboxImages.length - 1 ? prev + 1 : 0))}
      />
    </div>
  )
}
